import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';
import themeable from 'rlink-theme/themeable';

import InputBase from './InputBase';

export default class SelectInput extends InputBase {
  get inputType () {
    return 'select';
  }

  get choices () {
    return this.fromPropsOrContext('choices');
  }

  get placeholder () {
    return this.fromPropsOrContext('placeholder');
  }

  get multiple () {
    return this.fromPropsOrContext('multiple');
  }


  normalizeValue (value) {
    if (this.multiple) {
      if (Array.isArray(value)) {
        return value;
      } else {
        return [value];
      }
    } else {
      return value;
    }
  }

  handleChange (ev) {
    let value;
    if (this.multiple) {
      value = [];
      for (let option of ev.target.options) {
        if (option.selected) {
          value.push((ev.value !== '-1')
            ? this.choices[Number(option.value)].value
            : this.props.emptyValue);
        }
      }
    } else {
      value = (ev.value !== '-1')
        ? this.choices[Number(ev.value)].value
        : this.props.emptyValue;
    }
    this.fireCommitValue(ev, value);
    return super.handleChange({
      event: ev,
      value,
    });
  }

  hasValue (value) {
    if (this.multiple) {
      return value && value.length > 0;
    } else {
      return value !== undefined && value !== null;
    }
  }


  getPlaceholder () {
    if (this.placeholder) {
      return (<option value="-1">{this.placeholder}</option>);
    }
  }

  updateSelect (ev) {
    let value = this.normalizeValue(ev.target.value);
    this.handleChange({
      event: ev,
      value,
    });
  }

  renderInput () {
    return (
      <select
        required={this.props.required}
        disabled={this.props.disabled}
        value={this.choices.map(choice => choice.value).indexOf(this.value)}
        onChange={ev => this.updateSelect(ev)}>
        {this.getPlaceholder()}
        {this.props.choices.map((option, idx) => <option
          key={idx}
          value={idx}>
          {option.label}
        </option> )}
      </select>
    );
  }
}

mergeStaticOptions(SelectInput, {
  propTypes: {
    placeholder: PropTypes.string,
    choices: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.any,
    })),
    multiple: PropTypes.bool,
    emptyValue: PropTypes.any,
  },
  defaultProps: {
    emptyValue: null,
    choices: [],
    placeholder: ' ',
    multiple: false,
  },
});

themeable(SelectInput, {
  classes: [
    'Label',
    'InputSelect',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/SelectInput.jsx